<div class="modal-header">
  <h4 class="modal-title pull-left"> {{ isEdit ? 'Edit Email': 'New Email' }} </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <page-user-edit-email
    [edit]="isEdit" [user]="user"
    (onCreate)="onConfirm($event)"
    (onCancel)="onCancel()">
  </page-user-edit-email>
</div>
